import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssMarkdownPage extends ComponentBase {

    protected id: guid = guid();
    protected value = '[Reddit](https://reddit.com "Reddit Home")';
    protected tooltipHeader = 'UDF 1';

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////

    ////****************** Example 2 ********************************************////

    ////****************** Example 3 ********************************************////

}
